/**
 * Color utilities
 * @namespace ColorUtils
 */

import { chartColors } from "./staticVariables";

export default class ColorUtils {
    /**
     * Generate random color
     * @memberof ColorUtils
     * @param {Array} colors - Array of colors
     * @returns {String} - Random color
     */
    static randomColor(colors) {
        if(!colors) colors = chartColors;
        console.log('colors', colors, colors[Math.floor(Math.random() * colors.length)])
        return colors[Math.floor(Math.random() * colors.length)]
    }
}